<template>
    <div class="check-template">
        <!-- 搜索框 -->
        <ul class="check-template-title">
            <li>
                <span class="template-title">{{$translate('lang.E3202102250023', { defaultText: '模板编码' })}}:</span>
                <span class="check-template-input"> <el-input v-model="form.templateCode"></el-input></span>
                <span class="template-title">{{$translate('lang.E3202102250024', { defaultText: '模板名称' })}}:</span>
                <span class="check-template-input"><el-input v-model="form.templateName" ></el-input></span>
            </li>
            <li><el-button @click="getSearch" size="small" type="primary" :loading="searchBlock">{{$translate('lang.E3202101260004', { defaultText: '查询' })}}</el-button></li>
        </ul>
        <!-- 表格 -->
        <el-table
            border
            :data="tableData"
            style="width: 100%">
            <el-table-column
                prop="name"
                width="100">
                <template slot-scope="scope">
                    <el-radio :label="scope.$index" v-model="radio" @change.native="getTemplateRow(scope.$index,scope.row)">&nbsp;</el-radio>
                </template>
            </el-table-column>
            <el-table-column
                :label="$translate('lang.E3202102250023', { defaultText: '模板编码' })"
                align="center"
                width="100">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.productTemplateCode" placement="top-start">
                        <span>{{scope.row.productTemplateCode}}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column
                prop="productTemplateName"
                align="center"
                :label="$translate('lang.E3202102250024', { defaultText: '模板名称' })">
            </el-table-column>
        </el-table>
        <div class="check-bottom">
            <pageList v-if="pageState" :pageMenu="pageMenu" @changeCurrent="currentDom" @changeSize="sizeDom" class="check-page"></pageList>
        </div>
    </div>
</template>
<script>
import { queryTemplate } from '../../../api/product';
import pageList from './checkPage';
export default {
    data() {
        return {
            pageState: true,
            searchBlock: false,
            radio: '',
            form: {
                templateCode: '',
                templateName: ''
            },
            tableData: [],
            pushTemplate: {
                productTemplateId: '',
                productTemplateCode: '',
                productTemplateName: ''
            },
            pageMenu: {
                totalCount: 0,
                currentPage: 1,
                pageNo: 1, // 初始页
                pageSize: 5, // 每页个数
                pageSizes: [5, 20, 30, 40]
            }
        };
    },
    methods: {
        getSearch() {
            this.pageState = false;
            this.pageMenu.pageNo = 1;
            this.searchBlock = true;
            this.getTemplate();
            this.$nextTick(() => {
                this.pageState = true;
            });
        },
        // 点击查询，获取模板信息
        getTemplate() {
            queryTemplate({
                templateCode: this.form.templateCode,
                templateName: this.form.templateName,
                pageNo: this.pageMenu.pageNo,
                pageSize: this.pageMenu.pageSize,
                status: 'Y'
            }).then(res => {
                this.pageMenu.totalCount = res.data.totalCount;
                var arr = [];
                res.data.list.forEach(function(item) {
                    arr.push({
                        productTemplateId: item.id,
                        productTemplateCode: item.templateCode,
                        productTemplateName: item.templateName
                    });
                });
                this.tableData = arr;
                this.searchBlock = false;
            }).catch(() => {
                this.searchBlock = false;
            });
        },
        getTemplateRow(index, row) {
            Object.keys(this.pushTemplate).forEach(key => {
                this.pushTemplate[key] = row[key];
            });
        },
        // 分页1
        currentDom(val) {
            this.pageMenu.pageNo = val;
            this.getTemplate();
        },
        // 分页2
        sizeDom(val) {
            this.pageMenu.pageSize = val;
            this.getTemplate();
        }
    },
    components: {
        pageList
    },
    mounted() {
        this.getSearch();
    }
};
</script>
<style lang='less'>
.check-template{
    .check-template-title{
        display: flex;
        justify-content: space-between;
        margin: 5px 0;
        li{
                display: flex;
                align-items: center;
        .template-title{
            width:90px;
            text-align: right;
            margin-right: 2px;
        }
        .check-template-input{
          width: 30%;
          margin-right: 10px;
        }
            }
    }
    .check-bottom{
        .check-page{
            text-align: right;
            margin-top: 20px;
        }
    }
}
</style>